import React from 'react'

export const HidePricing = ({ children }) => {
  const hidePricing = process.env.GATSBY_HIDE_PRICING === 'true'

  if (hidePricing) {
    return null
  }

  return <>{children}</>
}
